module.exports = __webpack_public_path__ + "img/verify_check_green.9e30c578.svg";